import { useFormContext } from 'react-hook-form';

import { DynamicFormControl } from '@/components/DynamicFormControl';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import DynamicFormField from '../../DynamicFormField';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { shouldShowClientSecretFields } from '../authenticationVisibility.utils';

/**
 * Client secret fields component.
 * Renders dynamic form fields for client secret authentication.
 * Used for traditional client secret authentication method.
 */
const ClientSecretFields = () => {
  const { formState } = useFormContext();
  const { errors } = formState;

  const {
    connectionInputSchema,
    selectedSourceTypeId,
    authenticationMode,
    isResettingSourceType
  } = useCloudSourceForm();

  if (isResettingSourceType) return null;

  if (
    !shouldShowClientSecretFields(authenticationMode, connectionInputSchema)
  ) {
    return null;
  }

  return (
    <>
      {connectionInputSchema?.client_secret_inputs?.map((d) => (
        <DynamicFormField
          formField={d}
          key={`${selectedSourceTypeId}-${d.name}`}
          xs={12}
          sm={6}
          md={4}
        >
          <DynamicFormControl {...d} />
          {errors[d.name] && <ErrorMessage message={errors[d.name]?.message} />}
        </DynamicFormField>
      ))}
    </>
  );
};

export default ClientSecretFields;
